import * as React from 'react';
import { useStore } from 'zustand';
import { CriteriaStoreContext } from '../context';

export const useCriteriaStoreDeletePredicate = () => {
    const { store } = React.useContext(CriteriaStoreContext);
    if (!store) throw new Error('Missing CriteriaStoreContext.Provider in the tree');
    const deletePredicate = useStore(store, (s) => s.deletePredicate);

    return deletePredicate;
};
